<template>
  <div>
    <mdb-modal centered @close="handleClose" elegant>
      <mdb-modal-header>
        <mdb-modal-title class="isi-heading-blue">Data Privacy</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body>
        <p class="mb-4 mt-n3">
          To show you test studio locations on a map we use the service "Bing
          Maps" by Microsoft Corporation, One Microsoft Way, Redmond, WA
          98052-6399, USA.
        </p>
        <p>
          Please make sure you accept the data privacy implications given by the
          <a
            href="https://www.microsoft.com/en-us/maps/product/terms-april-2011"
            target="_blank"
            >Microsoft Bing Maps and MapPoint Web Service End User Terms of Use
            and Embedded Maps Service Terms of Use</a
          >.
        </p>
        <mdb-btn class="btn btn-isi" @click="handleAccept">Accept</mdb-btn>
        <mdb-btn class="btn-isi-secondary" @click="handleClose">Close</mdb-btn>
      </mdb-modal-body>
    </mdb-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    options: {
      type: Object,
      required: true,
    },
  },
  methods: {
    handleClose() {
      this.$store.commit("clearCurrentModal");
    },
    handleAccept() {
      if (this.$store.state.user) {
        this.$http({
          method: "post",
          url: "/api/UserAction/BingMapsAgree",
        });
      }
      this.$store.commit("acceptBingMaps");
      this.$store.commit("clearCurrentModal");
      this.options.callback();
    },
  },
};
</script>

<style>
</style>